import React from 'react';
import { Alert, Button, Input } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import SystemModal from 'components/Shared/Modal';
import { CheckCircleGreenIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const CloseWalletModal = ({
  visible,
  isClosed,
  isLoading,
  refundNote,
  onRefundNoteChange,
  onCancel,
  onConfirm,
}) => {
  const { translateText } = useTranslation();

  return (
    <SystemModal
      visible={visible}
      destroyOnClose
      closable={!isClosed}
      onCancel={onCancel}
      onOk={isClosed ? undefined : onConfirm}
      okText={translateText(
        'corporateAccounts.wallet.dashboard.footer.close.confirm.confirmButton',
      )}
      cancelText={translateText('corporateAccounts.actions.cancel')}
      okButtonProps={{
        type: 'primary',
        danger: true,
        loading: isLoading,
        'data-testid': 'walletCloseModalConfirm',
      }}
      footer={isClosed ? null : undefined}
      title={
        isClosed ? '' : translateText('corporateAccounts.wallet.dashboard.footer.close.button')
      }
      width={480}
    >
      {isClosed ? (
        <div className={styles.closeDone} data-testid="walletCloseModalDone">
          <span className={styles.closeDoneIcon}>
            <CheckCircleGreenIcon />
          </span>
          <div className={styles.closeDoneTitle}>
            {translateText('corporateAccounts.wallet.dashboard.footer.close.done.title')}
          </div>
          <div className={styles.closeDoneDescription}>
            {translateText('corporateAccounts.wallet.dashboard.footer.close.done.description')}
          </div>
          <Button type="primary" onClick={onCancel} data-testid="walletCloseModalDoneButton">
            {translateText('corporateAccounts.actions.done')}
          </Button>
        </div>
      ) : (
        <>
          <Alert
            data-testid="walletCloseModalCallout"
            type="info"
            showIcon
            icon={<InfoCircleOutlined />}
            message={translateText(
              'corporateAccounts.wallet.dashboard.footer.close.confirm.calloutCopy',
            )}
            style={{ marginBottom: 14 }}
          />
          <div className={styles.fieldLabel}>
            {translateText('corporateAccounts.wallet.dashboard.footer.close.confirm.noteLabel')}
          </div>
          <Input.TextArea
            value={refundNote}
            onChange={event => onRefundNoteChange(event.target.value)}
            rows={3}
            data-testid="walletCloseModalNote"
          />
        </>
      )}
    </SystemModal>
  );
};

export default CloseWalletModal;
